import { ErrorHandler, Injectable, isDevMode } from '@angular/core';

/**
 * Global Error Handler for the portfolio.
 * Captures all unhandled exceptions and logs them to the console.
 * In production, this can be extended to send logs to a monitoring service like Sentry or Datadog.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  public handleError(error: unknown): void {
    const message = error instanceof Error ? error.message : String(error);

    // Log to console with appropriate styling
    console.error(`[Global Error Handler]: ${message}`, {
      error,
      timestamp: new Date().toISOString(),
      url: typeof window !== 'undefined' ? window.location.href : 'SSR',
    });

    // PENDING: Integrate with monitoring service (Sentry/Datadog)
    if (!isDevMode()) {
      // Example: Sentry.captureException(error);
    }
  }
}
